export const PAYOUT_TYPES = [
  { value: 'threshold_excess', label: '기준 초과분 지급: (점수 - 기준) x 단가' },
  { value: 'per_point', label: '점수당 지급: 점수 x 단가' },
  { value: 'fixed', label: '고정 금액' },
];

export const PAYOUT_LABELS = {
  threshold_excess: '기준 초과분 지급',
  per_point: '점수당 지급',
  fixed: '고정 금액',
  emergency_team_weekly: '비상대응팀 주당 지급',
};

export const EMERGENCY_COMPONENT_SOURCE = 'emergency_team_weekend';

export const isEmergencyComponent = (component) => component?.source === EMERGENCY_COMPONENT_SOURCE;

export const monthValue = (year, month) => `${Number(year)}-${String(Number(month)).padStart(2, '0')}`;

export const monthLabel = (value) => {
  if (!value) return null;
  const text = String(value).slice(0, 7);
  if (text === '1900-01') return '기존 기준';
  return `${Number(text.slice(0, 4))}년 ${Number(text.slice(5, 7))}월부터`;
};

export const numFmt = (n) => Number(n || 0).toLocaleString();
